import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Tengo que hacer ejercicio intenso?',
  a: 'No, el protocolo recomienda movimiento estratégico de bajo impacto para no disparar el estrés.'
}, {
  q: '¿Es una dieta keto?',
  a: 'No, es una alimentación equilibrada que enseña a tu cuerpo a gestionar los carbohidratos en el momento adecuado.'
}, {
  q: '¿Cuándo recibiré el producto?',
  a: 'El acceso es inmediato tras la compra; recibirás los audios en tu correo para escucharlos hoy mismo.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-cream" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <FadeIn data-id="element-22">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-12 text-center" data-id="element-23">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-24">
            {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-sage/20 overflow-hidden" data-id="element-25">
                <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-26">
                  <span className="font-serif text-lg text-charcoal font-medium" data-id="element-27">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: openIdx === idx ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-28">
                    <ChevronDown className="text-sage" data-id="element-29" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-30">
                  {openIdx === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-31">
                      <div className="px-6 pb-5 font-sans text-charcoal/70 leading-relaxed" data-id="element-32">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}